import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import styles from '../MuslinTwoLayer/MuslinTwoLayer.module.scss'
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs'
import CarouselPhoto from '../../../components/CarouselPhoto/CarouselPhoto'
import { arrFuter} from '../../../utils/data'
import WidthDensity from '../../../components/WidthDensity/WidthDensity'
import ColorsList from '../../../components/ColorsList/ColorsList'
import Popular from '../../../components/Popular/Popular'
import { arrPopular } from '../../../utils/data'



const Futer = ({isOpen}) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

        return (
            <section 
            className={styles.main} 
            >
            <BreadCrumbs
                text={'Футер'}
            >
                <p className={styles.menu_text}><span>&ensp;/&ensp;</span></p>
                <Link className={styles.menu_link} to='/tkani'>Ткани в наличии</Link>
            </BreadCrumbs>
            <div className={styles.box}>
                <div className={styles.list_image}>
                    <CarouselPhoto
                        arr={arrFuter}
                    />
                </div>
                <div className={styles.box_info}>
                    <div>
                        <h2 className={styles.title}>Футер</h2>
                        <p className={styles.subtitle}>трикотажное полотно</p>
                    </div>
                    <div className={styles.line}></div>
                        <WidthDensity
                            type='2-х нитка'
                            width='180'
                            density='240'
                        />
                        <WidthDensity
                            type='3-х нитка'
                            width='180'
                            density='340'
                        />
                        <div className={styles.line}></div>
                        <ColorsList
                        arr={arrFuter}
                        />
                        <button className={styles.button} type='button' onClick={isOpen}>заказать Футер</button>
                </div>
            </div>
            <Popular
                arr={arrPopular}
            />   
            </section>
        )
    }
    
    export default Futer